import {
	CIRCLE_BUTTON_HOVER_WASH_CLASS,
	CIRCLE_BUTTON_SOLID_SYSTEM_SURFACE_CLASS,
	circleButtonSizeClassName,
} from "../../custom/circle-button";
import { cn } from "../../../lib/cn";

import {
	CTA_SECONDARY_ELEVATION_CLASS,
	CTA_SURFACE_TRANSITION_CLASS,
} from "./cta-surface-classes";
import { PRIMARY_CTA_FOOTPRINT_CLASS } from "./primary-cta-classname";

const SECONDARY_CTA_GRADIENT_SURFACE = cn(
	"overflow-hidden",
	"bg-gradient-to-b from-white via-neutral-50 to-neutral-100 text-neutral-900",
	"dark:from-[#243652] dark:via-[#1a2435] dark:to-[#0f1419] dark:text-white",
	CTA_SECONDARY_ELEVATION_CLASS,
);

/**
 * `RippleButton` with `appearance="plain"`: same footprint as {@link PRIMARY_CTA_CLASSNAME}, vertical
 * gradient + inset ring (light: white/neutral; dark: navy). Pass `whileHover` / `whileTap` from
 * `cta-ripple-motion.ts` — plain appearance does not apply scale motion by default.
 */
export const SECONDARY_CTA_CLASSNAME = cn(
	PRIMARY_CTA_FOOTPRINT_CLASS,
	SECONDARY_CTA_GRADIENT_SURFACE,
	"disabled:cursor-not-allowed disabled:opacity-60 disabled:saturate-50",
);

/**
 * {@link RippleButton}'s `asChild` branch uses `Button` + Slot only — merge the same neutral surface
 * so `SecondaryCta asChild` (e.g. `Link`) matches non-slotted secondary CTAs.
 */
export const SECONDARY_CTA_SLOTTED_CHROME = cn(
	"relative",
	SECONDARY_CTA_GRADIENT_SURFACE,
	CTA_SURFACE_TRANSITION_CLASS,
	"disabled:cursor-not-allowed disabled:opacity-60 disabled:saturate-50",
	"aria-disabled:cursor-not-allowed aria-disabled:opacity-60 aria-disabled:saturate-50",
);

/** Pass to `RippleButton` `rippleClassName` with {@link SECONDARY_CTA_CLASSNAME}. */
export const SECONDARY_CTA_RIPPLE_CLASSNAME =
	"bg-foreground/20 dark:bg-white/25";

/**
 * Circle surface shared with {@link CircleButton} `chrome="solid"` `tone="system"`.
 * Prefer {@link CircleButton} for new controls.
 */
export const SECONDARY_CTA_ICON_CIRCLE_SURFACE_CLASS = cn(
	"relative inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full",
	"[&>*]:relative [&>*]:z-[1]",
	CIRCLE_BUTTON_SOLID_SYSTEM_SURFACE_CLASS,
	"transition-[opacity,background-color,color,box-shadow] duration-200",
	"disabled:cursor-not-allowed disabled:opacity-40",
	CIRCLE_BUTTON_HOVER_WASH_CLASS,
	"cursor-pointer",
	"focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
	"[&_svg]:!size-4 [&_svg]:block [&_svg]:shrink-0",
	"[&_svg]:[transform:translate3d(0,0,0)] [&_svg]:[backface-visibility:hidden]",
);

/**
 * Size-8 icon circle — prefer {@link CircleButton} `size="sm"` `chrome="solid"`.
 */
export const SECONDARY_CTA_ICON_CIRCLE_CLASS = cn(
	SECONDARY_CTA_ICON_CIRCLE_SURFACE_CLASS,
	circleButtonSizeClassName.sm,
);
